class DisplayAds extends HTMLElement {
  constructor() {
    super()
    this.adNetwork = this.dataset.adNetwork
    this.adClient = this.dataset.adClient
    this.adList = JSON.parse(this.dataset.adList)
    this.renderAds()
  }

  createAdContainer(children, elemClass) {
    const container = document.createElement('div')
    container.className = `${elemClass} advert`
    container.append(...children)
    return container
  }

  createAdSlot(id) {
    const insScript = document.createElement('ins')
    insScript.classList.add('adsbygoogle')
    insScript.setAttribute('data-ad-slot', id)
    insScript.setAttribute('data-ad-client', this.adClient)
    insScript.setAttribute('data-ad-format', "auto")
    insScript.setAttribute('data-full-width-response', "true")
    // insScript.style.width = "728px"
    // insScript.style.height = "90px"

    return insScript
  }

  createAdPushScript() {
    const pushAds = document.createElement('script')
    pushAds.textContent = '(adsbygoogle = window.adsbygoogle || []).push({});'
    return pushAds
  }

  createNetworkScript() {
    const allScripts = document.head.querySelectorAll('script');
    let scriptExists = false
    allScripts.forEach(script => { 
      if(script.src.includes('adsbygoogle')) { 
        scriptExists = true
      }
    }) 
    if(scriptExists === false && this.adClient !== '') {
      const adScript = document.createElement('script')
      adScript.setAttribute('type', 'text/javascript')
      adScript.setAttribute(
        'src',
        `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${this.adClient}`
      )
      adScript.setAttribute('async', '')
      adScript.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(adScript)
    }
  }

  createImageAd(obj, elem, elemClass, aspectRatio) {
    const adHtml = `
      <div class="${elemClass} advert">
        <a href="${obj.link}" target="_blank" rel="${obj.sponsored ? 'sponsored' : ''}" class="${aspectRatio ? aspectRatio : 'auto'}" title="${
      obj.image_alt ? obj.image_alt : 'advert'
    }">
          <img src="${obj.image}" alt="${
      obj.image_alt
    }" style="object-position: ${obj.image_focal_point}">
        </a>
      </div>
    `
    const position = obj.position || 'beforeend'
    elem.insertAdjacentHTML(position, adHtml)
  }

  createScriptAd(obj, elem, elemClass) {
    // const networkScript = this.createNetworkScript()
    const adSlot = this.createAdSlot(obj.ad_slot)
    const pushAds = this.createAdPushScript()
    const container = this.createAdContainer([adSlot,pushAds], elemClass)

    const position = obj.position || 'beforebegin'
    if (position === 'beforebegin') {
      elem.before(container)
    } else {
      elem.after(container)
    }
  }

  renderAd(ad, elem, aspectRatio,hasImageBg) {
    if(hasImageBg) { 
      elem.classList.add('bg-image')
    }
    if (ad.type === 'ad_unit') {
      this.createNetworkScript()
      this.createScriptAd(ad, elem, '')
    } else {
      this.createImageAd(ad, elem, elem.className, aspectRatio)
    }
  }

  renderAds() {
    this.adList.forEach((ad) => {
      const elem = document.querySelector(`[data-ad-target="${ad.id}"]`)

      let aspectRatio = null
      let hasImageBg = false

      if(elem && elem.children.length > 0) {
        let ratio = Array.from(elem.children[0].classList).filter(cls => {
          if(cls.includes('aspect-')) {
            return cls
          }
        }).toString()

        // See if image is bg
        const childElem = elem.querySelector('div')
        Array.from(childElem.classList).filter(cls => { 
          if(cls.includes('has-image')) { 
            hasImageBg = true
          }
        })

        if(ratio === '' && elem.querySelector('.blog-post__image')) { 
          const image = elem.querySelector('.blog-post__image')
          aspectRatio = Array.from(image.classList).filter(cls => {
            if(cls.includes('aspect-')) {
              return cls
            }
          }).toString()
        }
      }
            
      if (elem) {
        this.renderAd(ad, elem, aspectRatio, hasImageBg)
      }
    })
  }
}

if (!window.customElements.get('display-ads')) {
  customElements.define('display-ads', DisplayAds)
}
